export default "__VITE_ASSET__BtgdhJWm__"